module.exports = __webpack_public_path__ + "img/bank.0a473bfd.png";